import { RESET } from '../actionTypes';
import { supplierIntegrationsActions } from '../reducer';

export default () => supplierIntegrationsActions[RESET]();
